export default __webpack_public_path__ + "files/videos/df43db9339214b9101bc00663ed69a24.mp4";